jQuery(function ($) {
    // Factory wheel/tire sizes accordion removed — only compatible wheels remain.
    let compatibleLoading = false;

    function closeFitmentTips($root) {
        ($root && $root.length ? $root : $(document))
            .find('[data-fitment-tip].is-open')
            .removeClass('is-open')
            .attr('aria-expanded', 'false');
        ($root && $root.length ? $root : $(document))
            .find('.car-compatible-wheel-card.is-fitment-tip-open')
            .removeClass('is-fitment-tip-open');
    }

    function initCompatibleWheelFitTips(root) {
        const $section = root && root.jquery
            ? root
            : $(root || '#car-compatible-wheels-section');
        if (!$section.length || $section.data('fitment-tips-ready') === 1) {
            return;
        }
        $section.data('fitment-tips-ready', 1);

        $section.on('click', '[data-fitment-tip]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $btn = $(this);
            const $card = $btn.closest('.car-compatible-wheel-card');
            const wasOpen = $btn.hasClass('is-open');
            closeFitmentTips($section);
            if (!wasOpen) {
                $btn.addClass('is-open').attr('aria-expanded', 'true');
                $card.addClass('is-fitment-tip-open');
            }
        });

        // Hover also needs the card above neighbors (CSS :has covers most browsers;
        // class keeps stacking stable while the tip is visible).
        $section.on('mouseenter focusin', '[data-fitment-tip]', function () {
            $(this).closest('.car-compatible-wheel-card').addClass('is-fitment-tip-open');
        });
        $section.on('mouseleave focusout', '[data-fitment-tip]', function () {
            const $btn = $(this);
            if ($btn.hasClass('is-open')) {
                return;
            }
            $btn.closest('.car-compatible-wheel-card').removeClass('is-fitment-tip-open');
        });
    }

    function initCompatibleWheelsNav(root) {
        const section = root && root.nodeType === 1
            ? root
            : document.getElementById('car-compatible-wheels-section');
        if (!section || section.getAttribute('data-nav-ready') === '1') {
            return;
        }

        const scroller = section.querySelector('[data-compatible-wheels-scroll]');
        const prevBtn = section.querySelector('[data-compatible-wheels-prev]');
        const nextBtn = section.querySelector('[data-compatible-wheels-next]');
        if (!scroller || !prevBtn || !nextBtn) {
            return;
        }

        section.setAttribute('data-nav-ready', '1');

        function stepSize() {
            const card = scroller.querySelector('.car-compatible-wheel-card');
            if (!card) {
                return Math.max(240, Math.round(scroller.clientWidth * 0.8));
            }
            const styles = window.getComputedStyle(scroller);
            const gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
            return Math.round(card.getBoundingClientRect().width + gap);
        }

        function updateNav() {
            const maxScroll = scroller.scrollWidth - scroller.clientWidth;
            const canScroll = maxScroll > 8;
            prevBtn.hidden = !canScroll;
            nextBtn.hidden = !canScroll;
            if (!canScroll) {
                return;
            }
            const left = scroller.scrollLeft;
            prevBtn.disabled = left <= 4;
            nextBtn.disabled = left >= maxScroll - 4;
        }

        function scrollByDir(dir) {
            const prefersReduced = window.matchMedia
                && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            scroller.scrollBy({
                left: dir * stepSize(),
                behavior: prefersReduced ? 'auto' : 'smooth'
            });
        }

        prevBtn.addEventListener('click', function () {
            scrollByDir(-1);
        });
        nextBtn.addEventListener('click', function () {
            scrollByDir(1);
        });
        scroller.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);

        // Images can change scrollWidth after load
        scroller.querySelectorAll('img').forEach(function (img) {
            if (!img.complete) {
                img.addEventListener('load', updateNav, { once: true });
            }
        });

        updateNav();
        window.setTimeout(updateNav, 100);
    }

    function applyCompatibleWheelsHtml(html) {
        const trimmed = typeof html === 'string' ? html.trim() : '';
        const $current = $('#car-compatible-wheels-section').first();
        if (!$current.length) {
            return;
        }
        if (trimmed) {
            $current.replaceWith(trimmed);
            const next = document.getElementById('car-compatible-wheels-section');
            initCompatibleWheelsNav(next);
            initCompatibleWheelFitTips(next);
            return;
        }
        // No matching offers — hide the section
        $current.remove();
    }

    function refreshCompatibleWheels(response) {
        if (response && typeof response.compatible_wheels_html === 'string') {
            applyCompatibleWheelsHtml(response.compatible_wheels_html);
            return;
        }

        const wheels = response && Array.isArray(response.compatible_wheels)
            ? response.compatible_wheels
            : (response && Array.isArray(response.wheels) ? response.wheels : []);
        const $current = $('#car-compatible-wheels-section').first();
        if (!wheels.length && $current.length) {
            $current.remove();
        }
    }

    /**
     * When Wheel-Size fitment is not cached, SSR shows a loading shell and/or beta
     * panel with data-fitment-backfill. Fetch once via AJAX (quota-gated).
     */
    function loadPendingCompatibleWheels() {
        const $pending = $('#car-compatible-wheels-section[data-pending="1"]');
        const $backfill = $('[data-fitment-backfill="1"][data-car-id]').first();
        const carId = parseInt(
            ($pending.length ? $pending.data('car-id') : 0)
                || ($backfill.length ? $backfill.data('car-id') : 0),
            10
        ) || 0;

        if ((! $pending.length && ! $backfill.length) || compatibleLoading) {
            return;
        }
        if (!carId) {
            if ($pending.length) {
                $pending.remove();
            }
            return;
        }

        compatibleLoading = true;

        $.ajax({
            url: '/ajax/catalog/cars/' + carId + '/wheel-sizes',
            method: 'GET',
            dataType: 'json',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).done(function (response) {
            refreshCompatibleWheels(response);
            const html = response && response.fitment_debug_html
                ? String(response.fitment_debug_html)
                : '';
            const $debug = $('[data-beta-fitment-debug]').first();
            if (html && $debug.length) {
                const wasOpen = $debug.prop('open');
                $debug.replaceWith(html);
                $('[data-beta-fitment-debug]').first().prop('open', wasOpen);
            } else if ($backfill.length && response && response.fitment_debug) {
                // Clear backfill marker when quota/API could not fill yet so we do not loop.
                const specs = response.fitment_debug.car_wheel_specs;
                const filled = Array.isArray(specs) && specs.some(function (row) {
                    return row && String(row.status || '') === 'ok' && Number(row.sizes_count || 0) > 0;
                });
                if (filled) {
                    $backfill.removeAttr('data-fitment-backfill');
                }
            }
        }).fail(function () {
            if ($pending.length) {
                $pending.remove();
            }
        }).always(function () {
            compatibleLoading = false;
        });
    }

    loadPendingCompatibleWheels();
    initCompatibleWheelsNav();
    initCompatibleWheelFitTips();
});
